import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { useIntl } from 'react-intl';
import { FACILITIES_NEARBY_LIMIT } from '../../constants/facilitiesNearby';
import ApolloQuery from '../../modules/react/components/stateful/ApolloQuery';
import FacilitiesMapWithLegend from '../components/stateful/FacilitiesMapWithLegend';
import FacilitiesMapWithLegendPrimaryFacility from './FacilitiesMapWithLegendPrimaryFacility';

const GET_FACILITY = gql`
  query GetFacilitiesNearbyFacilityMapWithLegendData($id: ID!, $limit: Int!, $live: Boolean!, $locale: String!, $maxDistanceInMiles: Int) {
    facility(id: $id) {
      id
      facilitiesNearby(filter: { limit: $limit, live: $live, locale: $locale, maxDistanceInMiles: $maxDistanceInMiles }) {
        id
        ...FacilitiesMapWithLegendFacility
      }
    }
  }

  ${FacilitiesMapWithLegend.fragments.facility}
`;

const propTypes = {
  facilityId: PropTypes.string.isRequired,
  maxDistanceInMiles: PropTypes.number,
  primaryFacilityId: PropTypes.string,
};

const defaultProps = {
  maxDistanceInMiles: undefined,
  primaryFacilityId: undefined,
};

const FacilitiesNearbyFacilityMapWithLegend = ({
  facilityId,
  maxDistanceInMiles,
  primaryFacilityId,
  ...rest
}) => {
  const { locale } = useIntl();

  return (
    <ApolloQuery
      query={GET_FACILITY}
      variables={{
        id: facilityId,
        limit: FACILITIES_NEARBY_LIMIT,
        live: true,
        locale,
        maxDistanceInMiles,
      }}
    >
      {({ facility }) => (
        <FacilitiesMapWithLegendPrimaryFacility
          primaryFacilityId={primaryFacilityId}
          facilities={facility.facilitiesNearby}
        >
          {facilities => (
            <FacilitiesMapWithLegend
              {...rest}
              facilities={facilities}
              primaryFacilityId={primaryFacilityId}
            />
          )}
        </FacilitiesMapWithLegendPrimaryFacility>
      )}
    </ApolloQuery>
  );
};

FacilitiesNearbyFacilityMapWithLegend.propTypes = propTypes;
FacilitiesNearbyFacilityMapWithLegend.defaultProps = defaultProps;

export default FacilitiesNearbyFacilityMapWithLegend;
